<template>
  <div role="progressbar" aria-valuemin="0" aria-valuemax="100" class="itex-progress el-progress el-progress--circle">
    <div class="el-progress-circle" style="height: 108px; width: 108px;">
      <svg viewBox="0 0 100 100">
        <path
          d="
            M 50 50
            m 0 -42
            a 42 42 0 1 1 0 84
            a 42 42 0 1 1 0 -84
          "
          stroke="#F5F5F5"
          :stroke-width="strokeWidth"
          fill="none"
          class="el-progress-circle__track"
          :style="{'stroke-dasharray': '263.894px, 263.894px', 'stroke-dashoffset': '0px'}"
        />
        <path
          d="
              M 50 50
              m 0 -42
              a 42 42 0 1 1 0 84
              a 42 42 0 1 1 0 -84
            "
          :stroke="color"
          fill="none"
          stroke-linecap="round"
          :stroke-width="strokeWidth"
          class="el-progress-circle__path"
          :style="{
            'stroke-dasharray': `${Math.abs(percentage)*2.63894}px, 263.894px`,
            'stroke-dashoffset': '0px',
            'transition': 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s'
          }"
        />
      </svg>
    </div>
    <div
      class="el-progress__text"
      :style="{'font-size': '18px'}"
    >{{ content }}</div>
    <p class="el-progress__tip">{{ text }}</p>
  </div>
</template>

<script>
import i18n from '@/lang';
import variables from '@klinx/components/packages/styles/variables.module.scss';

export default {
  name: 'ProgressBar',
  props: {
    color: {
      type: String,
      default: variables.main
    },
    percentage: {
      type: Number,
      default: 50
    },
    content: {
      type: Number || String,
      default: 0 || i18n.t('内容')
    },
    text: {
      type: String,
      default: i18n.t('百分比')
    },
    strokeWidth: {
      type: Number,
      default: 14
    }
  },
  data() {
    return {

    };
  },
  created() {

  },
  methods: {

  }
};
</script>

<style lang='scss' scoped>
.itex-progress{
  &.el-progress{
    margin: 10px;

    .el-progress__text{
      font-weight: 700;
      top: 45%;
    }
    .el-progress__tip{
      position: absolute;
      top: 60%;
      left: 0;
      width: 100%;
      text-align: center;
      margin: 0;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.45);
    }
  }
}
</style>
